
import { DossierConfigService } from "@/services";
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { SortRowsProp, sortSaleRowsByExtraField, sortSaleRowsByProductExtraField, sortSaleRowsByProp } from "@/utils/sale-edit/sale-edit-state-sort-rows";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true
		}
	},
	computed: {
		items():ISelectItem<SortRowsProp>[]{
			return getEnumKeys(SortRowsProp).map(s=>{
				let val = getEnumValueFromKey(SortRowsProp, s);
				return {
					text: this.$ct(`sort-row-prop.${s}`),
					value: val
				} as ISelectItem<SortRowsProp>;
			});
		},
		sortByExtraFieldItems():ISelectItem<string>[] {
			let settings = DossierConfigService.getExtraFieldNamesConfigs().SaleRowNames;
			let activeFields = settings.getActiveFields();
			return activeFields.map(a=>{
				return {
					text: settings.getFieldName(a),
					value: a
				} as ISelectItem<string>;
			});
		},
		sortByProductExtraFieldItems():ISelectItem<string>[] {
			let settings = DossierConfigService.getExtraFieldNamesConfigs().ProductNames;
			let activeFields = settings.getActiveFields();
			return activeFields.map(a=>{
				return {
					text: settings.getFieldName(a),
					value: a
				} as ISelectItem<string>;
			});
		}
	},
	methods: {
		sort(val:SortRowsProp){
			sortSaleRowsByProp(this.state.sale, val);
			this.close();
		},
		sortByExtraFields(val:string){
			sortSaleRowsByExtraField(this.state.sale, val);
			this.close();
		},
		sortByProductExtraFields(val:string){
			sortSaleRowsByProductExtraField(this.state.sale, val);
			this.close();
		},
		close(){
			this.state.sortRowsModalOpen = false;
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
